import * as Yup from "yup";

export const SignInSchema = Yup.object({
  email: Yup.string().required("*Required").email("Invalid email"),
  password: Yup.string().required("*Required"),
});

export const PackageSchema = Yup.object({
  packageName: Yup.string().required("*Required"),
});

export const SubPackageSchema = Yup.object({
  name: Yup.string().required("*Required"),
  image: Yup.string().required("*Required"),
  description: Yup.string()
    .required("*Required")
    .max(1500, "Max 1500 characters allowed"),
  label: Yup.string().required("*Required"),
  status: Yup.string().required("*Required"),
  days: Yup.number()
    .required("*Required")
    .positive("Must be greater than zero")
    .typeError("Must be number"),
  nights: Yup.number()
    .required("*Required")
    .positive("Must be greater than zero")
    .typeError("Must be number"),
  price: Yup.number()
    .required("*Required")
    .positive("Must be greater than zero")
    .typeError("Must be number"),
  rating: Yup.number()
    .required("*Required")
    .positive("Must be greater than zero")
    .typeError("Must be number")
    .max(5, "Maximum 5 star allowed"),
  discountPrice: Yup.number()
    .required("*Required")
    .positive("Must be greater than zero")
    .typeError("Must be number")
    .max(
      Yup.ref("price"),
      "Discount Price cannot be more than Original Price"
    ),
  itinerary: Yup.array().min(1, "Minimum 1 itinerary required"),
  package_id: Yup.string().required("*Required"),
});

export const ItenarySchema = Yup.object({
  day: Yup.number()
    .required("*Required")
    .positive("Must be greater than zero")
    .typeError("Must be number"),
  title: Yup.string()
    .required("*Required")
    .max(200, "Max 200 characters allowed"),
  description: Yup.string()
    .required("*Required")
    .max(2000, "Max 2000 characters allowed"),
});

export const InclusionSchema = Yup.object({
  content: Yup.string()
    .required("*Required")
    .max(500, "Max 500 characters allowed"),
});

export const ExclusionSchema = Yup.object({
  content: Yup.string()
    .required("*Required")
    .max(500, "Max 500 characters allowed"),
});

export const TestimonialSchema = Yup.object({
  name: Yup.string()
    .required("*Required")
    .max(100, "Max 100 characters allowed"),
  content: Yup.string()
    .required("*Required")
    .max(1000, "Max 500 characters allowed"),
  image: Yup.string().required("*Required"),
});

export const ActivitySchema = Yup.object({
  name: Yup.string()
    .required("*Required")
    .max(100, "Max 100 characters allowed"),
  description: Yup.string()
    .required("*Required")
    .max(500, "Max 500 characters allowed"),
  image: Yup.string().required("*Required"),
  duration: Yup.string().required("*Required"),
  groupSize: Yup.string().required("*Required"),
});

export const TopAttractionSchema = Yup.object({
  name: Yup.string().required("*Required").max(100, "Max 100 characters allowed"),
  description: Yup.string()
    .required("*Required")
    .max(500, "Max 500 characters allowed"),
  image: Yup.string().required("*Required"),
  location: Yup.string().required("*Required"),
  detailedDescription: Yup.string()
    .required("*Required")
    .max(3000, "Max 3000 characters allowed"),
  highlights: Yup.string().required("*Required"),
  bestTime: Yup.string().required("*Required"),
  howToReach: Yup.string()
    .required("*Required")
    .max(1000, "Max 1000 characters allowed"),
  thingsToDo: Yup.string().required("*Required"),
  nearbyAttractions: Yup.string().required("*Required"),
});

export const HotelSchema = Yup.object({
  name: Yup.string().required("*Required").max(50, "Max 50 characters allowed"),
  description: Yup.string()
    .required("*Required")
    .max(2000, "Max 500 characters allowed"),
  image: Yup.array().min(1, "Minimum 1 image required").max(5, "Max 5 images"),
  rating: Yup.number()
    .required("*Required")
    .positive("Must be greater than zero")
    .typeError("Must be number")
    .max(5, "Miximum 5 star allowed"),
  location: Yup.string()
    .required("*Required")
    .max(50, "Max 50 characters allowed"),
  propertyType: Yup.string().required("*Required"),
});

export const FaqSchema = Yup.object({
  question: Yup.string().required("*Required"),
  answer: Yup.string().required("*Required"),
});

export const ChangePasswordSchema = Yup.object({
  currentPassword: Yup.string().required("*Required"),
  newPassword: Yup.string()
    .required("*Required")
    .min(6, "Password must be at least 6 characters"),
  confirmPassword: Yup.string()
    .required("*Required")
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
});

export const UpdateProfileSchema = Yup.object({
  email: Yup.string().required("*Required").email("Invalid email"),
});

export const GallerySchema = Yup.object({
  title: Yup.string()
    .required("*Required")
    .max(100, "Max 100 characters allowed"),
  src: Yup.string().required("*Required"),
});

export const BlogSchema = Yup.object({
  title: Yup.string().required("*Required").max(200, "Max 200 characters allowed"),
  excerpt: Yup.string().required("*Required").max(500, "Max 500 characters allowed"),
  content: Yup.string().required("*Required"),
  author: Yup.string().required("*Required").max(100, "Max 100 characters allowed"),
  date: Yup.string().required("*Required"),
  category: Yup.string().required("*Required").max(100, "Max 100 characters allowed"),
  readTime: Yup.string().required("*Required").max(50, "Max 50 characters allowed"),
  image: Yup.string().optional(),
});

export const TaxiSchema = Yup.object({
  name: Yup.string().required("*Required").max(100, "Max 100 characters allowed"),
  type: Yup.string().required("*Required").oneOf(["car", "bike"], "Invalid type"),
  description: Yup.string().required("*Required").max(1000, "Max 1000 characters allowed"),
  image: Yup.string().required("*Required"),
  pricePerDay: Yup.number().required("*Required").positive("Must be greater than zero").typeError("Must be number"),
  seats: Yup.number().required("*Required").positive("Must be greater than zero").typeError("Must be number"),
  luggage: Yup.number().required("*Required").min(0, "Cannot be negative").typeError("Must be number"),
  priority: Yup.number().min(0, "Cannot be negative").typeError("Must be number"),
});
